<template>
  <div class="step3">
    <div class="bgBox">
      <div
        class="systemBox"
        v-for="(item, index) in appList"
        :key="item.addId"
        :class="activeIndex.indexOf(index) > -1 ? 'systemBox-active' : ''"
        @click="selectApp(item, index)"
      >
        <div class="logo">
          <img :src="item.logo" alt="logo" />
          <span>{{ item.name }}</span>
        </div>
        <div class="triangle">
          <i class="el-icon-check"></i>
        </div>
      </div>
    </div>
    <el-form>
      <el-button
        style="width:410px;margin: 28px auto;"
        round
        @click="submitForm('ruleForm')"
        type="primary"
      >下一步</el-button>
      <el-button @click="goBackStep1">上一步</el-button>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import registerApi from 'api/register/register';

export default {
  computed: {
    ...mapGetters(['name', 'phone', 'password', 'orgId', 'orgName'])
  },

  data() {
    return {
      activeIndex: [],
      paramsForm: {
        name: '',
        phone: '',
        password: '',
        orgId: '',
        orgName: '',
        appIdList: []
      },
      appList: []
      //submitBtnLoading: false
    };
  },
  created() {
    this.paramsForm.name = this.name;
    this.paramsForm.phone = this.phone;
    this.paramsForm.password = this.password;
    this.paramsForm.orgId = this.orgId;
    this.paramsForm.orgName = this.orgName;
    this.getSysAppListData(this.paramsForm.orgName);
  },

  methods: {
    // 点击下一步
    submitForm(formName) {
      if (this.paramsForm.appIdList.length) {
        registerApi.postRegister(this.paramsForm).then(res => {
          if (res.data.code === 200) {
            this.submitBtnLoading = false;
            this.$emit('goToStep4', 4);
          }
          // else {
          //   this.$message.error(res.data.message);
          // }
        });
      } else {
        this.$message.error('请选择注册系统');
      }
    },
    goBackStep1() {
      this.paramsForm.appIdList = [];
      this.activeIndex = [];
      this.$emit('goBackStep2', 1);
    },

    // 根据 orgName 获取子系统列表
    getSysAppListData(orgName) {
      registerApi.getSysAppList(orgName).then(res => {
        if (res.data.code === 200) {
          this.appList = res.data.data;
          this.appList.forEach((item, index) => {
            this.paramsForm.appIdList.push(item.appId);
            this.activeIndex.push(index);
          });
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 点击选择或取消
    selectApp(data, index) {
      let selectAppList = this.paramsForm.appIdList;
      const itemIndex = selectAppList.indexOf(data.appId);
      if (itemIndex === -1) {
        selectAppList.push(data.appId);
      } else {
        selectAppList.splice(itemIndex, 1);
      }
      this.paramsForm.appIdList = selectAppList;
      // TODO:可优化 判断是否为选中状态
      let arrIndex = this.activeIndex.indexOf(index);
      if (arrIndex > -1) {
        this.activeIndex.splice(arrIndex, 1);
      } else {
        this.activeIndex.push(index);
      }
    }
  },
  watch: {
    orgName(newVal) {
      console.log('orgName', newVal);
      this.getSysAppListData(newVal);
      return newVal;
    },
    name(newVal) {
      console.log('name', newVal);
      this.paramsForm.name = newVal;
      return newVal;
    },
    phone(newVal) {
      console.log('phone', newVal);
      this.paramsForm.phone = newVal;
      return newVal;
    },
    password(newVal) {
      console.log('password', newVal);
      this.paramsForm.password = newVal;
      return newVal;
    },
    orgId(newVal) {
      console.log('orgId', newVal);
      this.paramsForm.orgId = newVal;
      return newVal;
    }
  }
};
</script>

<style lang="less" scoped>
.step3 {
  text-align: center;
  min-height: 416px;
  width: 100%;
  .bgBox {
    width: 90%;
    margin: 50px auto 0;
    height: 330px;
    overflow: auto;
    border: 1px solid #dcdfe7;
    display: flex;
    flex-wrap: wrap;
    padding: 24px;
    box-sizing: border-box;
    //justify-content: start;

    .systemBox {
      box-sizing: border-box;
      position: relative;
      width: 28%;
      height: 120px;
      margin-right: 16px;
      margin-bottom: 42px;
      padding: 20px 0 20px 0;
      background: #ffffff;
      border: 1px solid #dcdfe7;
      opacity: 1;
      border-radius: 10px;
      cursor: pointer;

      .triangle {
        transition: all 0.5s;
        position: absolute;
        top: 0;
        right: 0;
        width: 0;
        height: 0;
        border-top: 22px solid transparent;
        border-right: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 22px solid transparent;
        border-radius: 0 10px 0 0;

        .el-icon-check {
          color: #fff;
          position: absolute;
          top: -16px;
          right: -16px;
        }
      }

      .logo {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 80px;
        height: 80px;
        font-size: 18px;
        color: #303133;

        img {
          width: 80px;
          height: 80px;
          vertical-align: middle;
          margin-right: 12px;
        }
      }
    }

    .systemBox-active {
      border: none;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);

      .triangle {
        transition: all 0.5s;
        border-top: 22px solid #409dff;
        border-right: 22px solid #409dff;
      }
    }

    // .systemBox:hover {
    //   border: none;
    //   box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
    // }
    // .systemBox:hover .triangle {
    //   transition: all 0.8s;
    //   border-top: 22px solid #409dff;
    //   border-right: 22px solid #409dff;
    // }
  }
}

/deep/.el-button + .el-button {
  width: 410px;
  height: 40px;
  border: 1px solid #dcdfe7;
  background: #fff;
  display: block;
  border-radius: 20px;
  margin: 0 auto;
  color: #616266;
}
</style>
